import type { EmailTemplate } from '../lib/emailTemplatesApi';

// Email template fixtures for Test Mode Settings → Email templates tab.

export function buildEmailTemplates(): EmailTemplate[] {
  return [
    {
      key: 'overdue_invoice',
      subject: 'Facturi cu scadenta depasita — {{companyName}}',
      bodyHtml:
        '<p>Buna ziua, <strong>{{clientName}}</strong>,</p>\n<p>Va reamintim ca facturi in valoare de {{totalAmount}} {{currency}} au scadenta depasita.</p>\n{{invoiceTable}}\n<p>Va multumim,<br/>Echipa {{companyName}}</p>',
      variables: [
        { name: 'clientName' },
        { name: 'companyName' },
        { name: 'invoiceCount' },
        { name: 'totalAmount' },
        { name: 'currency' },
        { name: 'invoiceTable', html: true },
      ],
      isCustomized: false,
      updatedAt: null,
    },
    {
      key: 'welcome',
      subject: 'Bun venit in echipa {{companyName}}! Contul tau este gata',
      bodyHtml:
        '<p>Salut <strong>{{userName}}</strong>,</p>\n<p>Bun venit in echipa <strong>{{companyName}}</strong>! Contul tau a fost creat.</p>\n{{credentialsTable}}\n<p>Cu drag,<br/>Echipa {{companyName}}</p>',
      variables: [
        { name: 'userName' },
        { name: 'email' },
        { name: 'password' },
        { name: 'appUrl' },
        { name: 'companyName' },
        { name: 'credentialsTable', html: true },
      ],
      isCustomized: false,
      updatedAt: null,
    },
  ];
}
